import React from 'react';
import VideosAssignmentState from './videosAssignmentState/VideosAssignmentState';
import VideosSection from './components/VideosSection/VideosSection';
import RestaurantsSection from './components/RestaurantsSection/RestaurantsSection';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const VideosAssignmentPage: React.FC = () => {
	return (
		<VideosAssignmentState>
			<div className={style.container}>
				<VideosSection />
				<RestaurantsSection />
			</div>
			<ModalWindows />
		</VideosAssignmentState>
	);
};

export default VideosAssignmentPage;
